import { Component } from '@angular/core';

/**
 * NUC-114: routed host for the shared @nucleus/mail-template-ui manager
 * (registry list + editor with live preview, send-test, table builder, and
 * Thymeleaf variable extraction). All behaviour lives in the library; this is
 * just the wrapper so tasksense admins can manage the templates the mail-service
 * resolves at send time — same screen as the console + bookwise + goldfish.
 */
@Component({
  selector: 'app-mail-templates',
  standalone: false,
  template: `<nucleus-mail-template-manager></nucleus-mail-template-manager>`,
  styles: [':host { display: block; }'],
})
export class MailTemplatesComponent {}
